/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './toolbar.tpl.html';

angular
  .module('log.toolbar', [])
  /**
   * Controller for the log.toolbar template.
   */
  .controller('LogToolbarCtrl', function ($scope, $state, pagingUtils, VIEW_STATES) {
    /**
     * Utility function for showing the admin view.
     */
    $scope.goToAdmin = function () {
      // Set the current page to the first page
      pagingUtils.pagingInfo.audit.currentPage = 1;
      pagingUtils.pagingInfo.activity.currentPage = 1;
      $state.go(VIEW_STATES.ADMIN_HOME);
    };
  });
